import api from '@/utils/api.js'
import { deserializeJsonApi } from '@/utils/jsonApiDeserializer.js'
import { logErrorOnSentry } from '@/utils/errorReportingUtils'

export async function fetchFullMessageContent(
  chatroomId: string | number,
  messageId: string | number,
): Promise<string | null> {
  try {
    const response = await api.get(`/api/chatrooms/${chatroomId}/messages/latest_messages`, {
      params: { before: Number(messageId) + 1, limit: 1 },
    })
    const messages = await deserializeJsonApi(response.data)
    const message = messages.find(m => m.id == messageId)
    return message?.content ?? null
  } catch (error) {
    logErrorOnSentry(error, { chain: 'fetchFullMessageContent' })
    return null
  }
}
